<template>
<div>

  <template v-if='inline' >
    <template v-if='multiple' >
      <v-subheader
        v-if='label'
        class='overline pl-2' >
        {{label}}
        <v-spacer />
        <v-btn x-small icon
          @click='refresh'
          :loading="global.request.me.loading || global.request.lookups.loading" >
          <v-icon>mdi-replay</v-icon>
        </v-btn>
      </v-subheader>
      <v-checkbox dense hide-details class='pa-0 ma-0'
        v-for='location in locations'
        v-model='selected'
        :key="location.id"
        :value='location.id'
        :label='location.name' />
      <span class='caption grey--text' v-if='hint' v-text='hint' />

      <p v-if='locations && locations.length === 0' >
        We didn't find any locations for {{spaceName}}
      </p>
    </template>
  </template>
  <v-select v-else outlined
    v-model='selected'
    @click:prepend="(newlocationdialog=true)"
    :items='locations'
    item-text='name'
    item-value='id'
    :prepend-icon="prependIcon"
    :return-object='returnObject'
    :multiple='multiple'
    :dense='dense'
    v-bind='attrs' />

  <v-dialog v-model="newlocationdialog" >
    <new-location-wizard :space-id="spaceId" @close="newlocationdialog=false" />
  </v-dialog>
</div>
</template>
<script>
import NewLocationWizard from '@/components/actions/wizards/NewLocationWizard/index.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'LocationPicker',
  components: {NewLocationWizard},
  props: {
    value: {required: false},
    spaceId: {required: true},
    inline: { type: Boolean, default: false },
    label: { type: String, required: false },
    hint: { type: String, required: false },
    returnObject: {type: Boolean, default: true},
    multiple: {type: Boolean, default: true},
    dense: {type: Boolean, default: true},
    chips: {type: Boolean, default: false},
    attrs: { type: Object, default: () => {} },
    withnew: { type: Boolean, default: false },
    locationId: {required: false} // if you set the locationId, it will set value from the location in the store
  },
  data () {
    return {
      newlocationdialog: false,
      selected: null,
      request: {
        resource: 'ag.spaces',
        extra: 'addresses',
        result: {}
      }
    }
  },
  mounted () {
    if (!this.value) {
      this.clear()
    }
  },
  computed: {
    ...mapGetters('identity', ['spaceIds', 'getLocationsBySpaceId', 'getLocations']),
    prependIcon () {
      if (this.withnew) { return 'mdi-plus' }
      return null
    },
    spaceData () {
      if (this.spaceId) {
        return this.getSpaceById(this.spaceId)
      }
      return {}
    },
    spaceName () {
      return this.getObjectPath(this.spaceData, 'title', '')
    },
    locations () {
      if (this.spaceId) {
        return this.getLocationsBySpaceId(this.spaceId)
      }
      return this.getLocations
    },
    requestStatus () {
      return this.request.status
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.selected = this.value
        } else {
          if (this.multiple) { this.selected = [] }
          else { this.selected = null }
        }
      }
    },
    spaceId: {
      immediate: true,
      handler () { this.get() }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        let payload = {
          key: 'locations',
          values: {}
        }
        let locations = this.getObjectPath(this.request, 'result.results', [])
        payload.values[this.spaceId] = locations
        this.$store.commit('identity/setLookup', payload)
      }
    },
    selected () {
      if (this.returnObject) {
        this.$emit('input', this.selected)
      } else {
        if (this.selected && this.selected.id) {
          this.$emit('input', this.selected.id)
        } else {
          this.$emit('input', this.selected)
        }
      }
    }
  },
  methods: {
    get () {
      if (this.spaceId) {
        this.request.resourceId = this.spaceId
        return this.$request('get', this.request)
      }
    },
    refresh () {
      this.init()
    },
    clear () {
      if (this.multiple) { this.selected = [] }
      else { this.selected = null }
    }
    // emitInput () {
    //   if (this.selected) {
    //     if (this.returnObject) {
    //       this.$emit('input', this.selected)
    //     } else {
    //       if (this.multiple) {
    //         let items = this.selected.map((loc) => { return loc.id })
    //         this.$emit('input', items)
    //       } else {
    //         this.$emit('input', this.selected.id)
    //       }
    //     }
    //   } else {
    //     this.$emit('input', this.selected)
    //   }
    // }
  }
}
</script>
